import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveBodiesStepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveBodiesStep = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveBodiesStepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveBodiesStep
      ? parseLegalClient(data.legalClientSaveBodiesStep)
      : undefined,
    loading,
    error,
    saveBodiesStep: useCallback(
      async (id: string) => {
        const res = await handle({
          variables: {
            id,
          },
        });
        return res.data?.legalClientSaveBodiesStep
          ? parseLegalClient(res.data.legalClientSaveBodiesStep)
          : undefined;
      },
      [handle]
    ),
  };
};
